import { epecToken } from '@/modules/projectA/utils/globalData';
import Api from '@/modules/projectA/api/cms/index';
// 视频
export const { videoFileUpload } = Api;
// 图片
export const { zoneConfigurationImageUpload } = Api;
// 证书
export const { certificateUpload } = Api;

export const headers = epecToken;
